import React, {useState} from 'react';
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import { Col, Row } from "react-bootstrap";
import { Card, Button} from "@mui/material";
import { useNavigate } from "react-router-dom";
import  {ProductsList} from "../ProductsList/ProductsList"

const Products = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const handleNavigation = (product) => {navigate(`/product-details/${product.id}`, { state: { product } });};
    const filteredProducts = ProductsList.filter(product =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="bg-offWhite">
            <NavBar products={ProductsList} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            <div style={{ paddingTop: "12rem" }}>
                <div className="d-flex justify-content-center" style={{ backgroundColor: "#A6CE3A" }}>
                    <h2 className="text-white fw-bold pt-5 pb-4">OUR PRODUCTS</h2>
                </div>
                <section className="container py-5">
                    <p className="text-black mt-3 fs-5">
                        {filteredProducts.length} {filteredProducts.length === 1 ? "Product" : "Products"}
                    </p>
                    <Row className="g-4 justify-content-center">
                        {filteredProducts.length > 0 ? (
                            filteredProducts.map((product) => (
                                <Col key={product.id} lg={3} md={4} sm={6} xs={10} className="d-flex justify-content-center">
                                    <Card className="product-card text-center p-4">
                                        <img src={product.image} alt={product.name} className="mb-3 w-100" loading="lazy"/>
                                        <h5 className="fw-semibold">{product.name}</h5>
                                        <p className="text-muted">{product.description}</p>
                                        <Button variant="contained" size="small" sx={{mt: 2, backgroundColor: "#A6CE3A", textTransform: 'none', fontWeight: 'bold', '&:hover': {backgroundColor: "#8AB330"}}} onClick={() => handleNavigation(product)}>View More Details</Button>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <div className="no-products-found text-center mt-5">
                                <h4>No products found !</h4>
                            </div>
                        )}
                    </Row>
                </section>
                <Footer />
            </div>
        </div>
    );
};
export default Products;
